import { useEffect } from 'react';
import { useMediaDevice } from './hooks';
import LoopPlayback from './LoopPlayback';
import styles from './index.module.scss';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { t } = useLang('Oasis.Brands');
    const { locale } = getLocal();

    const { isH5, isPad, isDesktop, isPC } = useMediaDevice();
    const list = [
        'https://websiteoss.ecoflow.com/upload/image/1733379763143/1.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379761271/2.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379761451/3.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379761733/4.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379761975/5.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379762282/6.png',
        // 'https://websiteoss.ecoflow.com/upload/image/1733379762562/7.png',
        'https://websiteoss.ecoflow.com/upload/image/1733379762868/8.png',
    ];

    useEffect(() => {
        const brands = document.querySelector('#SeamLess') as HTMLVideoElement;
        if (isH5) {
            brands.style.opacity = '1';
            return;
        }

        const ani = AniContainer.create({
            triggerElement: '#SeamLess',
            triggerHook: 1,
            offset: 0,
            duration: '200%',
            // asyncFromTo: [
            //     [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
            //     [brands, { opacity: 0 }, { opacity: 1 }, 0.1],
            //     [brands, { opacity: 1 }, { opacity: 0 }, 0.1],
            //     [brands, { opacity: 0 }, { opacity: 0 }, 0.1],
            // ],
            asyncFromTo: [
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
                [brands, { opacity: 1 }, { opacity: 1 }, 0.1],
            ],
            asyncTimeLine: [0, 0.1, 0.5, 1],
        });
        return () => {
            ani.destroy();
        };
    }, [isPad, isH5, isPC]);

    return (
        <div className={`${styles.TheComp}`} id="Brands">
            {/* <div className="brand-title">{t('title')}</div> */}
            {isH5 ? (
                <div>
                    {/* <LoopPlayback list={[list[0], list[1], list[2]]} reverse />
                    {<LoopPlayback list={[list[3], list[4], list[5], list[6]]} />} */}
                    <LoopPlayback list={list} reverse />
                </div>
            ) : (
                <div>
                    <LoopPlayback list={list} />
                    {['us', 'ca'].includes(locale) && <LoopPlayback list={list} reverse />}
                </div>
            )}
        </div>
    );
}
